import { http } from "../core";
import { URL } from "./_url";
import { StatusCode } from "../constant";

const apiFetchPlatmapInfo = async (areaName: string, communityName: string, neighborhoodName: string) => {
  const response = await http.get(URL.FETCH_PLATMAP_INFO(areaName, communityName, neighborhoodName));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

const apiFetchPlatmapsInfo = async (areaName: string, communityName: string) => {
  const response = await http.get(URL.FETCH_PLATMAPS_INFO(areaName, communityName));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

const apiFetchPlatmap = async (neighborhoodId: string, communityCode: string) => {
  const response = await http.get(URL.FETCH_PLATMAP(neighborhoodId, communityCode));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

const apiFetchPlatmapCordinates = async (neighborhoodId: string) => {
  const response = await http.get(URL.FETCH_PLATMAP_COORDINATES(neighborhoodId));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

const apiFetchHomePlans = async (neighborhoodId: string, communityCode: string) => {
  const response = await http.get(URL.FETCH_HOME_PLANS(neighborhoodId, communityCode));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

const apiFetchQmiHomePlans = async (communityCode: string) => {
  const response = await http.get(URL.FETCH_QMI_PLANS(communityCode));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

export { apiFetchPlatmap, apiFetchHomePlans, apiFetchPlatmapInfo, apiFetchPlatmapCordinates, apiFetchQmiHomePlans, apiFetchPlatmapsInfo };